<ngx-spinner [fullScreen]="true"
             bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"
             type="ball-clip-rotate-multiple">
</ngx-spinner>
<div class="teranet-center">
  <div id="main" role="main" fxLayout="row" fxLayoutAlign="center center" fxFlexFill>
    <div fxLayout="column" fxFlex="40">
      <div *ngFor="let item of types"
           class="icon-button"
           fxLayout="column"
           fxLayoutAlign="space-around stretch">
        <button mat-button (click)="routerLink(item)">
          <div class="btnicon">
            <fa-icon [icon]="item.icon" class="fa-lg" matTooltipPosition="above"></fa-icon>
          </div>
          <div class="btntext" style="float: left">{{ item.label }}</div>
        </button>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50">
      <div fxLayout="column" fxLayoutAlign="center">
        <h5>
          Welcome to Teranet Insurance Monitoring Platform.
        </h5>
        <h6>
          <br />
          As a user, you will continue to see this application evolve as Teranet introduces additional features and functionality.
        </h6>
      </div>
    </div>
  </div>
</div>
